import PropTypes from "prop-types";
import React, { useState } from "react";
import axios from "axios";
import Popup from "reactjs-popup";
import "./pageLayoutSelector.css";

const contentStyle = {
  border: "1px solid var(--sl-border-secondary)",
  borderRadius: "12px",
  boxShadow: "0 8px 8px -4px rgba(10,13,18,0.03), 0 20px 24px -4px rgba(10,13,18,0.08)",
  width: "360px",
  padding: "16px",
  background: "var(--sl-bg-primary)",
  zIndex: 9999,
};

const OPTIONS = [
  {
    value: "tabbed",
    icon: "fa-table-columns",
    label: "Tabbed",
    isNew: true,
    description: "Each section on its own tab. Faster to navigate big events.",
  },
  {
    value: "classic",
    icon: "fa-bars-staggered",
    label: "Classic",
    description: "Everything on one scrolling page, the way it was before.",
  },
];

const PageLayoutSelector = ({ layout, teamId, confirmId, csrfToken }) => {
  const [busy, setBusy] = useState(false);
  const current = OPTIONS.find((o) => o.value === layout) || OPTIONS[0];

  const urlFor = (value) =>
    value === "tabbed" ? `/teams/${teamId}/e/${confirmId}` : `/teams/${teamId}/confirms/${confirmId}`;

  const choose = (value, close) => {
    if (busy) return;
    if (value === layout) { close(); return; }
    setBusy(true);
    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
    axios
      .patch("/user_settings", {
        user: { event_page_layout: value },
      })
      .then(() => window.location.assign(urlFor(value)))
      .catch(() => setBusy(false));
  };

  return (
    <Popup
      arrow={false}
      offsetY={5}
      position="bottom right"
      keepTooltipInside
      contentStyle={contentStyle}
      trigger={
        <button type="button" className="pls-trigger" disabled={busy}>
          <i className="fas fa-table-columns" />
          <span className="pls-trigger-label">View:</span>
          <span className="pls-trigger-value">{current.label}</span>
          <i className="fas fa-chevron-down pls-chevron" />
        </button>
      }
    >
      {(close) => (
        <div className="pls-menu">
          <div className="pls-header">Page layout</div>
          <div className="pls-subhead">Your choice is remembered on this account.</div>
          {OPTIONS.map((o) => {
            const selected = o.value === layout;
            return (
              <button
                type="button"
                key={o.value}
                className={`pls-option${selected ? " is-selected" : ""}`}
                onClick={() => choose(o.value, close)}
              >
                <span className="pls-option-icon"><i className={`fas ${o.icon}`} /></span>
                <span className="pls-option-text">
                  <span className="pls-option-title">
                    {o.label}
                    {o.isNew && <span className="pls-badge-new">New</span>}
                  </span>
                  <span className="pls-option-desc">{o.description}</span>
                </span>
                {selected && <i className="fas fa-check pls-check" />}
              </button>
            );
          })}
        </div>
      )}
    </Popup>
  );
};

PageLayoutSelector.propTypes = {
  layout: PropTypes.oneOf(["classic", "tabbed"]).isRequired,
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  confirmId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  csrfToken: PropTypes.string,
};

export default PageLayoutSelector;
